module.exports = __webpack_public_path__ + "static/7-wheelchair-ebd2ad1ce9e06e9d0e0ffa3155f8be5c.jpg";